module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av442-85a7f8e5637f71cb2572220ceb571687.jpg";